import React, { useContext, useState, useEffect } from 'react';
import _, { isMap } from "lodash";
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import { Row, Col, Modal, Tabs, Tooltip } from 'antd';
import { CloseOutlined, HeartFilled, HeartOutlined } from '@ant-design/icons';
import { FAVOURITES_CONTROLLER } from '../../../../environments/env';
import ProductImageCarousel from './ProductImageCarousel';
import FileConstants from '../../../../FileConstants';
import ReactPlayer from 'react-player';
import ENVIRONMENT from '../../../../environments'
import axios from 'axios';

const { TabPane } = Tabs;
const CUSTOMER_USERNAME = localStorage.getItem("username");

const ProductAssetViewer = () => {
    const { productAssetData, hasGlb, product_id, selectedAsset, statusOf360Spin, statusOfMp4Video, setViewing3D, selectedProductImage,
        productAssetViewer, closeProductAssetViewer, setSelectedAsset, getDownloadUrl, favImages, isAiModel, productImageCount, modalRef,
        allProductImages, setSelectedImage, setSelectedProductImage, setSelectedImgOriginalFormat, setSelectedImgFilename, setSelectedImageResolution, aiImageCounts,
        setSelectedImageFormat, setSelectedImageName, setSelectedImageCapturedBy, setSelectedImageCreationDate, setSelectedImageType, setSelectedFilenameWithExtension, modelStatus, isAiGlbExists } = useContext(CustomerProductContext);

    const [isSpin360Fav, setIsSpin360Fav] = useState(false)
    const [isMp4Fav, setIsMp4Fav] = useState(false)
    const [spin360FavId, setSpin360FavId] = useState(-1)
    const [mp4FavId, setMp4FavId] = useState(-1)

    const changeAssetTab = (key) => {
        setSelectedAsset(key);
        if (key != "all") {
            setViewing3D(false);

            // Handle AI image tabs
            if (key === "final_images" || key === "1k_previews" || key === "ai_videos") {
                const filteredImages = allProductImages.filter(img => {
                    if (key === "final_images") {
                        return (img.main_type === 'ai_lifestyle') &&
                            img.is_final_image === true;
                    } else if (key === "1k_previews") {
                        return (img.main_type === 'ai_lifestyle') &&
                            !img.is_final_image;
                    } else if (key === "ai_videos") {
                        return img.main_type === 'ai_video';
                    }
                    return false;
                });

                if (filteredImages.length > 0) {
                    setImageDetails(filteredImages[0]);
                }
            } else if (!selectedProductImage) {
                if (allProductImages?.length > 0) {
                    setImageDetails(allProductImages[0])
                }
            }
        } else {

            if (isAiModel == false) {
                setViewing3D(true);
            } else if (isAiModel == true) {
                if (hasGlb() && key == 'all') {
                    setViewing3D(true);
                }
                else if (allProductImages?.length > 0) {
                    setViewing3D(false);
                    setImageDetails(allProductImages[0])
                }
            }
        }
    }

    const setImageDetails = (image) => {
        setSelectedImage(image);
        setSelectedProductImage(image.url);
        setSelectedImgOriginalFormat(image.format);
        setSelectedImgFilename(image.filename);
        setSelectedImageResolution(image.resolution);
        setSelectedImageFormat(image.format);
        setSelectedImageName(image.display_name);
        setSelectedImageCapturedBy(image.captured_by)
        setSelectedImageCreationDate(image.created_at);
        setSelectedImageType(image.main_type)
        setSelectedFilenameWithExtension(image.filename)
    };

    useEffect(() => {
        if (favImages) {
            favImages.filter(item => item.entity_id == product_id && item.entity_type == "product").map(obj => {
                if (obj.image_name == `${product_id}.mp4`) {
                    setIsMp4Fav(true)
                    setMp4FavId(obj.id)
                }
                else if (obj.image_name == `${product_id}_Frame1.jpg`) {
                    setIsSpin360Fav(true)
                    setSpin360FavId(obj.id)
                }
            })
        }
    }, [])

    const markFavorite = (assetType, imageName) => {
        let payload = {
            action: 'add_favorite',
            entity_id: product_id,
            entity_type: 'product',
            image_type: assetType,
            image_name: imageName,
            favorited_by: CUSTOMER_USERNAME
        }

        axios.post(FAVOURITES_CONTROLLER, payload).then(res => {
            if (res && res['data']?.favorite_id) {
                if (assetType == 'mp4') {
                    setMp4FavId(res['data']?.favorite_id)
                }
                else if (assetType == 'spin_360') {
                    setSpin360FavId(res['data']?.favorite_id)
                }
            }
        })
    }

    const markUnfavorite = (assetType, favId) => {
        let payload = {
            action: 'remove_favorite',
            favorite_id: favId,
            favorited_by: CUSTOMER_USERNAME
        }

        axios.post(FAVOURITES_CONTROLLER, payload)
        if (assetType == 'mp4') {
            setMp4FavId(-1)
        }
        else {
            setSpin360FavId(-1)
        }
    }

    const handleFavorite = (assetType) => {
        console.log('asset = ', assetType)
        if (assetType == 'mp4') {
            if (isMp4Fav) {
                setIsMp4Fav(false)
                markUnfavorite(assetType, mp4FavId)
            }
            else {
                setIsMp4Fav(true)
                markFavorite(assetType, `${product_id}.mp4`)
            }
        }
        else if (assetType == 'spin_360') {
            if (isSpin360Fav) {
                setIsSpin360Fav(false)
                markUnfavorite(assetType, spin360FavId)
            }
            else {
                setIsSpin360Fav(true)
                markFavorite(assetType, `${product_id}_Frame1.jpg`)
            }
        }


    }

    const renderFavIcon = (assetType) => {
        let favState = false
        if (assetType == 'mp4')
            favState = isMp4Fav
        else
            favState = isSpin360Fav
        return favState ? (
            <Tooltip title={<span className="manrope f-12 white">Unfavorite</span>}>
                <div
                    className="pointer-event-auto img-fav-icon-modal white"
                    onClick={(e) => handleFavorite(assetType)}
                >
                    <HeartFilled style={{ fontSize: "24px" }} />
                </div>
            </Tooltip>
        ) : (
            <Tooltip title={<span className="manrope f-12 white">Favorite</span>}>
                <div
                    className="pointer-event-auto img-fav-icon-modal white"
                    onClick={(e) => handleFavorite(assetType)}
                >
                    <HeartOutlined style={{ fontSize: "24px" }} />
                </div>
            </Tooltip>
        );
    }

    return (
        <div>
        {productAssetViewer && <div className='ai-image-viewer-modal-close-btn pdp-carousel'>
            <Tooltip title={<span className="manrope f-12 white">Close</span>}>
                <CloseOutlined className='manrope f-24 w-500 white' onClick={closeProductAssetViewer}/>
            </Tooltip>
        </div>}
        <Modal
            className={`${isAiModel ? 'product-asset-viewer-modal-ai' : 'product-asset-viewer-modal'}`}
            visible={productAssetViewer}
            footer={null}
            closable={false}
            destroyOnClose={true}
            onCancel={closeProductAssetViewer}>
            <Row ref={modalRef}>
                <Col span={24}>
                    <Tabs
                        className='items-table'
                        onChange={changeAssetTab}
                        tabBarGutter={32}
                        activeKey={selectedAsset}
                        size="large">
                        <TabPane tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "all" ? `selected` : ``}`}>All ({productImageCount})</span>}
                            key={"all"}
                            className='pd-0'>
                            <ProductImageCarousel />
                        </TabPane>
                        {isAiModel == false &&
                            <TabPane
                                tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "images" ? `selected` : ``}`}>Images ({productImageCount})</span>}
                                key={"images"}
                                className="pd-0">
                                <ProductImageCarousel />
                            </TabPane>}
                        {aiImageCounts?.finalAiImages > 0 && isAiModel == true && <TabPane
                            tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "final_images" ? `selected` : ``}`}>Final Images ({aiImageCounts.finalAiImages})</span>}
                            key={"final_images"}
                            className="pd-0">
                            <ProductImageCarousel tab_name={"final_images"} />
                        </TabPane>}
                        {aiImageCounts?.previewAiImages > 0 && isAiModel == true && <TabPane
                            tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "1k_previews" ? `selected` : ``}`}>Previews ({aiImageCounts.previewAiImages})</span>}
                            key={"1k_previews"}
                            className="pd-0">
                            <ProductImageCarousel tab_name={"1k_previews"} />
                        </TabPane>}
                        {aiImageCounts?.aiVideos > 0 && isAiModel == true && <TabPane
                            tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "ai_videos" ? `selected` : ``}`}>Videos ({aiImageCounts.aiVideos})</span>}
                            key={"ai_videos"}
                            className="pd-0">
                            <ProductImageCarousel tab_name={"ai_videos"} />
                        </TabPane>}
                        {modelStatus == 5 &&
                            <TabPane
                                tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "3d_preview" ? `selected` : ``}`}>3D Model</span>}
                                key={"3d_preview"}
                                className="pd-10">
                                <div className='glb-height'>
                                    <Row id='model-inspector-frame' className='model-inspector-viewer-customer'>
                                        <iframe id='model-viewer-3d' className='model-inspector-frame-customer' src={FileConstants.ModelInspector + product_id} />
                                    </Row>
                                </div>
                            </TabPane>}

                        {isAiGlbExists && modelStatus == 16 &&
                            <TabPane
                                tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "ai_model" ? `selected` : ``}`}>3D Model</span>}
                                key={"ai_model"}
                                className="pd-10">
                                <div className='glb-height'>
                                    <Row id='model-inspector-frame-ai' className='model-inspector-viewer-customer'>
                                        <iframe id='model-viewer-3d-ai' className='model-inspector-frame-customer' src={FileConstants.ModelInspector + product_id} />
                                    </Row>
                                </div>
                            </TabPane>
                        }

                        {statusOf360Spin && (
                            <TabPane
                                tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "360_view" ? `selected` : ``}`}>360 Spin</span>}
                                key={"360_view"}
                                className="pd-10">
                                <div className='overlay-container mt-50'>
                                    {renderFavIcon('spin_360')}
                                </div>
                                <div id="container-360" className={`${statusOf360Spin === "pending" ? `product-viewer-360-container-ms` : `product-viewer-360-container`}`}>
                                    {statusOf360Spin === "pending" ?
                                        (<div className="render-in-progress">
                                            360 Spin in Progress
                                        </div>) : (<div
                                            className="cloudimage-360"
                                            id="image-360"
                                            data-folder={productAssetData['360']?.["data-folder"]}
                                            data-filename={productAssetData['360']?.["data-filename"]}
                                            data-amount={productAssetData['360']?.["data-amount"]} />
                                        )}
                                </div>
                            </TabPane>
                        )}
                        {statusOfMp4Video && (
                            <TabPane
                                tab={<span className={`manrope f-14 asset-tab-heading ${selectedAsset === "mp4_video" ? `selected` : ``}`}>MP4 Video</span>}
                                key={"mp4_video"}
                                className="pd-10">
                                <Row className={`${statusOfMp4Video === "pending" ? `product-viewer-mp4-viewer` : ``} `}>
                                    {statusOfMp4Video === "pending" ?
                                        (<div className="render-in-progress">
                                            MP4 Video in Progress
                                        </div>) :
                                        <>
                                            <div className='overlay-container mt-50'>
                                                {renderFavIcon('mp4')}
                                            </div>
                                            <ReactPlayer
                                                width={"100%"}
                                                height={"calc(100vh - 140px)"}
                                                url={getDownloadUrl("VIDEO")}
                                                controls={true}
                                                loop={true} />
                                        </>}
                                </Row>
                            </TabPane>
                        )}
                    </Tabs>
                </Col>
            </Row>
        </Modal>
        </div>
    );
}

export default ProductAssetViewer;
